"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixSchemaPrefix = exports.reversalMergeDataByOneToOne = exports.mergeDataByOneToOne = exports.reversalFixDataPrefix = exports.fixDataPrefix = void 0;

var _lodash = require("lodash");

var _constant = require("./constant");

var _menu = require("./utils/menu");

/**
 * 数据包装成逍遥组件需要的格式: 字段都带上table的appid、schemaid前缀
 * @param {*} tableList table树生成的data树
 * @param {*} tableTree table
 */
var fixDataPrefix = function fixDataPrefix(dataList, table) {
  dataList.forEach(function ($data) {
    var data = $data;
    Object.keys(data).forEach(function (key) {
      // 找出当前table的子table集
      var forkTableArray = table.forkTableList.map(function (item) {
        return item.forkTable;
      }); // 如果符合子数据集的key值，说明是子表数据

      var forkTable = forkTableArray.find(function (item) {
        return "".concat(item.appId).concat(_constant.SPLIT).concat(item.schemaId) === key;
      });

      if (forkTable) {
        if (data[key] && data[key].length > 0) {
          fixDataPrefix(data[key], forkTable);
        }

        return;
      }

      var value = data[key];
      delete data[key];
      data["".concat(table.appId).concat(_constant.SPLIT).concat(table.schemaId).concat(_constant.SPLIT).concat(key)] = value;
    });
  });
};
/**
 * fixDataPrefix的还原函数
 * @param {*} tableList table树生成的data树
 * @param {*} tableTree table
 */


exports.fixDataPrefix = fixDataPrefix;

var reversalFixDataPrefix = function reversalFixDataPrefix(dataList, table) {
  dataList.forEach(function ($data) {
    var data = $data;
    Object.keys(data).forEach(function (key) {
      // 找出当前table的子table集
      var forkTableArray = table.forkTableList.map(function (item) {
        return item.forkTable;
      }); // 如果符合子数据集的key值，说明是子表数据

      var forkTable = forkTableArray.find(function (item) {
        return "".concat(item.appId).concat(_constant.SPLIT).concat(item.schemaId) === key;
      });

      if (forkTable) {
        if (data[key] && data[key].length > 0) {
          reversalFixDataPrefix(data[key], forkTable);
        }

        return;
      }

      var value = data[key];
      delete data[key];
      data[key.replace("".concat(table.appId).concat(_constant.SPLIT).concat(table.schemaId).concat(_constant.SPLIT), '')] = value;
    });
  });
};
/**
 * 一对一的主、从表，要打平成一条数据
 * @param {*} dataList
 * @param {*} relationList
 */


exports.reversalFixDataPrefix = reversalFixDataPrefix;

var mergeDataByOneToOne = function mergeDataByOneToOne(dataList, table) {
  dataList.forEach(function ($data) {
    var data = $data;
    Object.keys(data).forEach(function (key) {
      // 如果符合子数据集的key值，说明是子表数据
      var forkTableObj = table.forkTableList.find(function (item) {
        return "".concat(item.forkTable.appId).concat(_constant.SPLIT).concat(item.forkTable.schemaId) === key;
      });

      if (forkTableObj) {
        var relationObj = forkTableObj.relationObj,
            forkTable = forkTableObj.forkTable;
        var forkDataList = data[key]; // 一对一、普通的一对n但n是父节点、link的一对n但n是父节点

        if ((relationObj.ratio === '1' || relationObj.ratio === '2' && (relationObj.relation[1] === _menu.RelationStatus.LEFT || relationObj.relation[1] === _menu.RelationStatus.IN)) && forkDataList && forkDataList.length === 1) {
          // 是一对一的情况，打平成一条数据
          Object.keys(forkDataList[0]).forEach(function (forkKey) {
            data[forkKey] = forkDataList[0][forkKey];
          });
          delete data["".concat(forkTable.appId).concat(_constant.SPLIT).concat(forkTable.schemaId)];
          mergeDataByOneToOne([data], forkTable);
        } else {
          mergeDataByOneToOne(forkDataList, forkTable);
        }
      }
    });
  });
};
/**
 * mergeDataByOneToOne的还原函数
 * @param {*} dataList
 * @param {*} relationList
 */


exports.mergeDataByOneToOne = mergeDataByOneToOne;

var reversalMergeDataByOneToOne = function reversalMergeDataByOneToOne(dataList, table) {
  var tableKey = "".concat(table.appId).concat(_constant.SPLIT).concat(table.schemaId);
  var forkTableKeys = table.forkTableList.map(function (item) {
    return "".concat(item.forkTable.appId).concat(_constant.SPLIT).concat(item.forkTable.schemaId);
  });
  dataList.forEach(function ($data) {
    var data = $data;
    var excessData = {};
    Object.keys(data).forEach(function (key) {
      // 非table的基础字段、子节点表的数据：剔除
      if (!key.startsWith(tableKey) && forkTableKeys.indexOf(key) === -1) {
        excessData[key] = data[key];
        delete data[key];
      }
    });
    table.forkTableList.forEach(function (forkTableObj) {
      var relationObj = forkTableObj.relationObj,
          forkTable = forkTableObj.forkTable; // 一对一、普通的一对n但n是父节点、link的一对n但n是父节点

      if (relationObj.ratio === '1' || relationObj.ratio === '2' && (relationObj.relation[1] === _menu.RelationStatus.LEFT || relationObj.relation[1] === _menu.RelationStatus.IN)) {
        var forkData = (0, _lodash.cloneDeep)(excessData);
        reversalMergeDataByOneToOne([forkData], forkTable);
        var forkDataKeys = Object.keys(forkData);

        if (forkDataKeys.length > 0 && forkDataKeys.find(function (key) {
          return forkData[key];
        })) {
          // 一对一打平时，uicore给回的数据是有字段，但所有值为空（如果打回会被处理成新建，这里去掉）
          data["".concat(forkTable.appId).concat(_constant.SPLIT).concat(forkTable.schemaId)] = [forkData];
        }
      } else {
        var forkDataList = data["".concat(forkTable.appId).concat(_constant.SPLIT).concat(forkTable.schemaId)] || [];
        reversalMergeDataByOneToOne(forkDataList, forkTable);
      }
    });
  });
};
/**
 * 转成对外一致的分隔符
 * @param {*} schemaObj 从dataStore获取到的schema缓存
 */


exports.reversalMergeDataByOneToOne = reversalMergeDataByOneToOne;

var fixSchemaPrefix = function fixSchemaPrefix(schemaObj) {
  var newObj = {};
  Object.keys(schemaObj).forEach(function (key) {
    var newKey = key.split('.').join(_constant.SPLIT);
    newObj[newKey] = schemaObj[key];
  });
  return newObj;
};

exports.fixSchemaPrefix = fixSchemaPrefix;